<template>
  <div class='modal'>
    <Button @click="modalBtn(msg,handleSelectData,parentId)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-model="modal1"
      footer-hide
      :draggable="true"
    >
      <p slot="header">
        <span>{{msg}}功能</span>
      </p>
      <Form
        v-if="msg!='删除'"
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem
          style="margin-bottom:22px"
          label="名称"
          prop="modulename"
        >
          <Input
            v-model="formValidate.modulename"
            placeholder="请输入名称"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="编号"
          prop="modulecode"
        >
          <Input
            v-model="formValidate.modulecode"
            placeholder="请输入编号"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="链接"
          prop="moduleurl"
        >
          <Input
            v-model="formValidate.moduleurl"
            placeholder="请输入链接"
          ></Input>
        </FormItem>
        <FormItem label="上级">
          <Select v-model="formValidate.parentid">
            <Option
              :value="item.moduleid"
              v-for="(item,index) in parentList"
              :key="item.moduleid"
            >{{item.modulename}}</Option>
          </Select>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="排序"
          prop="sortcode"
        >
          <Input
            type="text"
            v-model="formValidate.sortcode"
            placeholder="请输入排序"
          ></Input>
        </FormItem>
        <Checkbox
          v-model="formValidate.isenable==1?true:false"
          style="margin:0px 50px 20px 80px"
          @on-change="boxChange"
        >有效</Checkbox>
        <FormItem label="备注">
          <Input
            v-model="formValidate.description"
            placeholder="请输入备注"
          ></Input>
        </FormItem>
        <FormItem style="margin-left:290px">
          <Button
            type="primary"
            @click="ok('formValidate')"
          >提交</Button>
        </FormItem>
      </Form>

      <p
        v-else
        style="text-align:center;font-size:20px"
      >
        <Icon
          style="font-size:30px;color:red"
          type="ios-alert-outline"
        />是否确认删除所选项
        <Button
          type="primary"
          style="margin-left:380px;margin-top:20px;width:80px"
          @click="del"
        >
          确定
        </Button>
      </p>

    </Modal>

  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      modal1: false,
      title: '',
      formValidate: {
        modulename: '',
        modulecode: '',
        sortcode: 0,
        parentid: '',
        moduleurl: '',
        description: '',
        isenable: 1,
        moduleId: '',

      },
      parentList: [],
      ruleValidate: {
        modulename: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        modulecode: [
          { required: true, message: '编号不能为空', trigger: 'blur' },
        ],
        sortcode: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
        ],
        moduleurl: [
          { required: true, message: '链接不能为空', trigger: 'blur' },
        ],
      },


    }
  },
  props: {
    msg: String,
    icon: String,
    handleSelectData: Object,
    parentId: Array,

  },
  created () {

  },
  methods: {
    async modalBtn (msg, handleSelectData, parentId) {
      this.parentList = this.$store.state.sysTreeList

      this.modal1 = true
      if (msg == '删除' || msg == '编辑') {
        if (handleSelectData == null) {
          this.$Message.info('您没有选中任何数据项,请选中后再操作！')
          this.modal1 = false
        }
      }
      if (msg == '编辑') {
        const req = await Api.sysFunction.GetDataById(this.handleSelectData.moduleid)
        if (req.success != true) return this.$Message.info(req.msg)
        this.formValidate = req.rows
        this.formValidate.sortcode = req.rows.sortcode + ''
        console.log(this.formValidate);

      }
    },
    ok (value) {
      this.$refs[value].validate(async (valid) => {
        if (valid) {
          if (this.msg == '新增') {
            const res = await Api.sysFunction.SaveData(this.formValidate)
            if (res.success != true) return this.Message.info(res.msg)
            this.$Message.info(res.msg);
            this.modal1 = false
            this.$router.go(0)
          } else if (this.msg == '编辑') {
            const res = await Api.sysFunction.SaveData(this.formValidate)
            if (res.success != true) return this.Message.info(res.msg)
            this.$Message.info(res.msg);
            this.modal1 = false
            this.$router.go(0)
          }
        } else {
          this.$Message.error('请确认表格信息完整!');
        }
      })
    },
    async del () {
      const res = await Api.sysFunction.DelData([this.handleSelectData.moduleid]);
      console.log(res);
      if (res.success != true) return this.Message.info(res.msg)
      this.$Message.success(res.msg)
      this.modal1 = false
    },

    //复选框事件
    boxChange (e) {
      if (e) {
        this.formValidate.isenable = 1
      } else {
        this.formValidate.isenable = 0
      }
    },

  }
}
</script>
<style lang='less' scoped>
.modal {
  display: inline-block;
  button {
    padding: 5px 10px;
    margin-left: 10px;
    text-align: center;
  }
}
</style>